import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.RecommendationCampaign,
});

export enum RecommendationCampaignFormTabs {
  General = "general",
  Audience = "audience",
  Uplift = "uplift",
}

/** i18n namespaces resolved to forms/recommendation-campaign/tabs/<tab>/locales */
export enum RecommendationCampaignI18n {
  /** Сама форма: `forms/recommendation-campaign/locales`. */
  Form = "module-recommendation-campaign-edit",
  AudienceTab = "module-recommendation-campaign-edit-audience",
  UpliftTab = "module-recommendation-campaign-edit-uplift",
}

/** Action endpoints of the backend module — not part of the resource itself. */
export const campaignActionUrl = (
  id: string,
  action:
    | "audience"
    | "uplift"
    | "customers"
    | "customers/csv"
    | "marketing-company"
    | "audience-breakdown",
) => `/recommendation/campaigns/${id}/${action}`;

export const campaignQueryKeys = {
  /**
   * Всё, что прочитано про одну кампанию: и плечи наверху, и список клиентов
   * внизу. Действие, меняющее аудиторию, обязано сбрасывать оба — иначе цифры
   * обновятся, а список под ними останется от прошлой жизни.
   */
  all: (campaignId: string) => ["recommendation-campaign", campaignId],
  customers: (
    campaignId: string,
    ownerId: string | undefined,
    group: string,
    page: number,
    pageSize: number,
    search: string = "",
    sort: { field: string; direction: string } | null = null,
  ) => [
    "recommendation-campaign",
    campaignId,
    "customers",
    ownerId ?? "",
    group,
    page,
    pageSize,
    search,
    sort === null ? "" : `${sort.field}:${sort.direction}`,
  ],
};
